import React from "react";
import { cleanName } from "../utils/parser";
import { rewardDic } from "../data/rewards";
import "./Score.css";

interface IScoreEntryProps {
  rewardKey: string;
  quantity: number;
  score: number;
}

function ScoreEntry(props: IScoreEntryProps) {
  const { rewardKey, quantity, score } = props;
  return (
    <div className="score-entry">
      <p>{`x${quantity} ${cleanName(rewardKey)}(s)`}</p>
      <p>=</p>
      <p>{score}</p>
    </div>
  );
}

function Total({ total }: { total: number }) {
  return (
    <div className="score-entry">
      <p>Total</p>
      <p>=</p>
      <p>{total}</p>
    </div>
  );
}

const calculateTotal = (entries: [string, number, any][], coin: number) => {
  return entries.reduce((total, [, quantity, score]) => {
    return total + score * quantity;
  }, coin);
};

interface IScoreProps {
  drops: Record<string, number>;
  coin: number;
}

export default function Score(props: IScoreProps) {
  const { drops, coin } = props;
  const entries = Object.entries(drops)
    .filter(([, count]) => count > 0)
    .map(
      ([key, quantity]) =>
        [key, quantity, rewardDic[`rewards/${key}`]?.score ?? 0] as [string, number, any]
    );
  const total = calculateTotal(entries, coin);
  return (
    <div className="score">
      <ScoreEntry rewardKey="coin" quantity={coin} score={coin} />
      {entries.map(([key, quantity, score]) => (
        <ScoreEntry key={key} rewardKey={key} quantity={quantity} score={score} />
      ))}
      <Total total={total} />
    </div>
  );
}
